import { useState } from "react";
import { ThumbsUp, ThumbsDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";

interface MessageFeedbackProps {
  conversationId: string;
  messageIndex: number;
}

export const MessageFeedback = ({ conversationId, messageIndex }: MessageFeedbackProps) => {
  const [feedback, setFeedback] = useState<boolean | null>(null);
  const { toast } = useToast();

  const handleFeedback = async (helpful: boolean) => {
    try {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) return;

      await supabase.from('conversation_feedback').insert({
        conversation_id: conversationId,
        user_id: user.id,
        helpful,
        message_id: null
      });

      setFeedback(helpful);
      toast({
        title: "Thank you for your feedback!",
        description: "This helps Giblet learn and improve.",
      });
    } catch (error) {
      console.error('Error submitting feedback:', error);
    }
  };

  return (
    <div className="flex items-center gap-1 mt-1">
      <Button
        variant="ghost"
        size="sm"
        className="h-6 w-6 p-0"
        onClick={() => handleFeedback(true)}
        disabled={feedback !== null}
      >
        <ThumbsUp className={`h-3 w-3 ${feedback === true ? 'fill-primary text-primary' : ''}`} />
      </Button>
      <Button
        variant="ghost"
        size="sm"
        className="h-6 w-6 p-0"
        onClick={() => handleFeedback(false)}
        disabled={feedback !== null}
      >
        <ThumbsDown className={`h-3 w-3 ${feedback === false ? 'fill-destructive text-destructive' : ''}`} />
      </Button>
    </div>
  );
};
